/**
 * Represent the model of the current behavior for Pagination
 */
export class PaginationModel {
	totalCount: number;
	offset: number;
	limit: number;
}

/**
 * To Control the Page Actions
 */
export enum PageActionType {
	FIRST = 0,
	PREVIOUS = 1,
	NEXT = 2,
	LAST = 3
}
